<div class="connector-type-list">
  <ng-container *ngFor="let connector of connectorTypes">
    <app-ev-station-connector-type [connectorType]="connector">
    </app-ev-station-connector-type>
  </ng-container>
</div>